import { Skeleton } from '@/components/ui/skeleton';

export const KpiSkeleton = () => (
  <div className="rounded-2xl border bg-card p-5 card-shadow">
    <div className="flex items-start justify-between">
      <Skeleton className="h-10 w-10 rounded-xl" />
      <Skeleton className="h-5 w-14 rounded-full" />
    </div>
    <Skeleton className="mt-4 h-3 w-24" />
    <Skeleton className="mt-2 h-8 w-28" />
    <Skeleton className="mt-3 h-10 w-full" />
  </div>
);

export const CardSkeleton = ({ height = 'h-72' }) => (
  <div className="rounded-2xl border bg-card p-5 card-shadow" data-testid="loading-skeleton">
    <Skeleton className="h-4 w-40" />
    <Skeleton className={`mt-4 w-full ${height}`} />
  </div>
);

export const GridSkeleton = ({ count = 4 }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
    {Array.from({ length: count }).map((_, i) => <KpiSkeleton key={i} />)}
  </div>
);
